import { Navigate } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/nav.js';
import Signup from './components/signup.js';
import Login from './components/login.js';
import MyContent from './pages/mycontent.js';
import Product from './pages/product.js';
import { useAuth } from './components/auth.js';
import Home from './pages/home.js';
// import Chat from './components/chat.js';
import './App.css';


// Django API base URL
function PrivateRoute({ children }) {
    const { user } = useAuth();
    return user ? children : <Navigate to="/" />;
  }



const App = () => {
  

    return (
        <div>
        <Router>
        <Navbar />
            <div className="container mt-4">
                <Routes>
                <Route path="/" element={<Home/>} />
                <Route path="/about" element={<h1>About Page</h1>} />
                <Route path="/product" element={<Product/>} />
                <Route path="/my-content" element={<PrivateRoute><MyContent /></PrivateRoute>} />
                <Route path="/contact" element={<h1>Contact Page</h1>} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/login" element={<Login />} />
                </Routes>
            </div>
        </Router>
        
           
            {/* <div className="App">
                <Chat />
            </div> */}
        </div>
    );
};

export default App;

